import axios from "axios";

export const api = axios.create({
  withCredentials: true,
  baseURL: "/api",
});

const errorHandler = (error) => {
  const statusCode = error.response?.status;

  switch (statusCode) {
    case 400:
      console.error("400 Bad Request", error.response.data);
      break;
    case 404:
      console.error("404 Not Found", error.response.data);
      break;
    case 500:
      console.error("500 Internal Server Error", error.response.data);
      break;
    default:
      console.error(statusCode, error.response?.data || error.message);
  }

  return Promise.reject(error);
};

api.interceptors.response.use(
  (response) => response,
  (error) => {
    return errorHandler(error);
  },
);
